<template>
  <div class="card p-4 shadow-sm">
    <!-- Filtros -->
    <div class="row mb-3 g-2">
      <div class="col-md-5">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar producto por nombre"
          v-model="busqueda"
        />
      </div>
      <div class="col-md-4">
        <select class="form-select" v-model="ordenarPor">
          <option value="">Ordenar por...</option>
          <option value="nombre-asc">Nombre (A-Z)</option>
          <option value="nombre-desc">Nombre (Z-A)</option>
        </select>
      </div>
      <div class="col-md-3">
        <button class="btn btn-secondary w-100" @click="limpiarFiltros">Limpiar</button>
      </div>
    </div>

    <!-- Toast de alerta -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i>
            {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- Encabezado -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="m-0">Inventario de Tienda</h3>
      <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Producto</button>
    </div>

    <!-- Formulario -->
    <div v-if="mostrarFormulario" class="mb-4">
      <h5 class="mb-3">Nuevo Producto</h5>
      <div class="row g-4">
        <div class="col-md-3">
          <label class="form-label">Nombre</label>
          <input v-model="nuevoProducto.Nombre" type="text" class="form-control" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Stock</label>
          <input v-model.number="nuevoProducto.Stock" type="number" min="0" class="form-control" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Precio Costo (Q)</label>
          <input v-model.number="nuevoProducto.PrecioCosto" type="number" min="0.01" step="0.01" class="form-control" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Precio Venta (Q)</label>
          <input v-model.number="nuevoProducto.PrecioVenta" type="number" min="0.01" step="0.01" class="form-control" />
        </div>
      </div>
      <div class="text-end mt-3">
        <button class="btn btn-primary me-2" @click="guardarProducto">Guardar</button>
        <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
      </div>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-bordered text-center align-middle">
        <thead class="table-light">
          <tr>
            <th>Nombre</th>
            <th>Stock</th>
            <th>Precio Costo (Q)</th>
            <th>Precio Venta (Q)</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="productosFiltrados.length === 0">
            <td colspan="5">No hay productos registrados.</td>
          </tr>
          <tr v-for="prod in productosFiltrados" :key="prod.IdProductoTienda">
            <td>{{ prod.Nombre }}</td>
            <td>{{ prod.Stock }}</td>
            <td>Q.{{ Number(prod.PrecioCosto).toFixed(2) }}</td>
            <td>Q.{{ Number(prod.PrecioVenta).toFixed(2) }}</td>
            <td>
              <button class="btn btn-primary btn-sm me-2" @click="abrirModal(prod)">Editar</button>
              <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(prod)">Eliminar</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal Actualizar -->
    <div v-if="mostrarModal" class="modal-backdrop">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Actualizar Producto</h5>
          <button type="button" class="btn-close" @click="cerrarModal"></button>
        </div>
        <div class="modal-body">
          <div class="row g-4">
            <div class="col-md-6">
              <label class="form-label">Nombre</label>
              <input v-model="productoEditar.Nombre" type="text" class="form-control" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Stock</label>
              <input v-model.number="productoEditar.Stock" type="number" min="0" class="form-control" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Precio Costo (Q)</label>
              <input v-model.number="productoEditar.PrecioCosto" type="number" min="0.01" step="0.01" class="form-control" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Precio Venta (Q)</label>
              <input v-model.number="productoEditar.PrecioVenta" type="number" min="0.01" step="0.01" class="form-control" />
            </div>
          </div>
        </div>
        <div class="modal-footer mt-3">
          <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
          <button class="btn btn-primary" @click="actualizarProducto">Actualizar</button>
        </div>
      </div>
    </div>

    <!-- Modal Eliminar -->
    <div v-if="mostrarModalEliminar" class="modal-backdrop">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
          <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
        </div>
        <div class="modal-body">
          <p>¿Eliminar el producto <strong>{{ productoEliminar?.Nombre }}</strong>?</p>
        </div>
        <div class="modal-footer mt-3">
          <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
          <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import debounce from "lodash/debounce";

export default {
  name: "ProductosTienda",
  data() {
    return {
      productos: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      busqueda: "",
      ordenarPor: "",
      productoEditar: null,
      productoEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevoProducto: {
        Nombre: "",
        Stock: "",
        PrecioCosto: "",
        PrecioVenta: ""
      }
    };
  },
  watch: {
    busqueda() {
      this.buscarProductoDebounce();
    }
  },
  created() {
    this.buscarProductoDebounce = debounce(this.buscarProducto, 400);
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    productosFiltrados() {
      if (!this.ordenarPor) return this.productos;
      const dir = this.ordenarPor.endsWith('-desc') ? -1 : 1;
      return this.productos.slice().sort((a, b) =>
        dir * (a.Nombre || '').localeCompare(b.Nombre || '')
      );
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    limpiarFiltros() {
      this.busqueda = "";
      this.ordenarPor = "";
      this.obtenerProductos();
    },
    async obtenerProductos() {
      try {
        const { data } = await axios.get(`${API_URL}/inventario-tienda`);
        this.productos = data;
      } catch (error) {
        console.error(error);
      }
    },
    async buscarProducto() {
      if (this.busqueda.trim() === "") {
        this.obtenerProductos();
        return;
      }
      try {
        const { data } = await axios.get(`${API_URL}/inventario-tienda/buscar/${this.busqueda}`);
        this.productos = data;
      } catch (error) {
        if (error.response?.status === 404) {
          this.productos = [];
          this.mostrarAlerta("No se encontraron productos.", "warning");
        } else {
          console.error(error);
          this.mostrarAlerta("Error al buscar productos.", "danger");
        }
      }
    },
    async guardarProducto() {
      const { Nombre, Stock, PrecioCosto, PrecioVenta } = this.nuevoProducto;
      if (!Nombre || Stock === "" || Stock === null || PrecioCosto === "" || PrecioCosto === null || PrecioVenta === "" || PrecioVenta === null) {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      if (Stock < 0) {
        this.mostrarAlerta("El stock no puede ser negativo", "danger");
        return;
      }
      try {
        const payload = {
          Nombre: Nombre,
          Stock: parseInt(Stock),
          PrecioCosto: parseFloat(PrecioCosto),
          PrecioVenta: parseFloat(PrecioVenta),
          StockMinimo: 0
        };
        await axios.post(`${API_URL}/inventario-tienda`, payload);
        this.mostrarAlerta("Producto agregado", "success");
        this.nuevoProducto = { Nombre: "", Stock: "", PrecioCosto: "", PrecioVenta: "" };
        this.mostrarFormulario = false;
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        const mensaje = error.response?.data?.message || "Error al guardar";
        this.mostrarAlerta(mensaje, "danger");
      }
    },
    abrirModal(producto) {
      this.productoEditar = { ...producto };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.productoEditar = null;
      this.mostrarModal = false;
    },
    async actualizarProducto() {
      if (this.productoEditar.Stock < 0) {
        this.mostrarAlerta("El stock no puede ser negativo", "danger");
        return;
      }
      try {
        await axios.put(`${API_URL}/inventario-tienda/${this.productoEditar.IdProductoTienda}`, this.productoEditar);
        this.mostrarAlerta("Producto actualizado", "success");
        this.cerrarModal();
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(producto) {
      this.productoEliminar = { ...producto };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.productoEliminar = null;
    },
    async confirmarEliminar() {
      if (!this.productoEliminar) return;
      try {
        await axios.delete(`${API_URL}/inventario-tienda/${this.productoEliminar.IdProductoTienda}`);
        this.mostrarAlerta("Producto eliminado", "success");
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoProducto = { Nombre: "", Stock: "", PrecioCosto: "", PrecioVenta: "" };
    }
  },
  mounted() {
    this.obtenerProductos();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 550px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
